import React from "react";
import { Box } from "@chakra-ui/layout";
import FormHeading from "../common-quote/FormHeading";
import TabSwitcher from "../TabSwitcher";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import { PdfGenerationActions } from "../../lib/types/PDFGenerationActions";

export interface QuoteFormHeadingProps {
  quoteName: string;
  formActionHandler: (action: QuoteFormActions, formValues: any) => void;
  formExportHandler: (action: PdfGenerationActions, formValues: any) => void;
  generatingPdf: boolean;
  isCalculating: boolean | undefined;
  quoteTabs: string[];
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
}

const QuoteFormHeading = (props: QuoteFormHeadingProps) => {
  return (
    <FormHeading
      label={props.quoteName}
      handler={props.formActionHandler}
      exportHandler={props.formExportHandler}
      generatingPdf={props.generatingPdf}
      calculating={props.isCalculating}
    >
      <Box
        marginBottom={{ base: 4, lg: 0 }}
        display={{ base: "none", lg: "block" }}
      >
        <TabSwitcher
          activeIndex={0}
          tabItems={props.quoteTabs}
          onTabClick={(index) => props.setTabIndex(index)}
        />
      </Box>
    </FormHeading>
  );
};

export default QuoteFormHeading;
